export default {
  roles: [],
  permissions: [],
  pagination: {},
};
